<template>
  <transition name="modal">
    <div class="modal-mask" v-bind:class="(top) ? 'top' : ''">
      <span class="fullCloseBtn" @click="$emit('close')" v-if="closeBtnPos == 'full'">
        <img src="~../assets/image/icon/btn_close.svg" width="30">
      </span>
      <div class="modal-wrapper">
        <div class="modal-container" v-bind:style="styleObject">
          <span class="windowCloseBtn" @click="$emit('close')" v-if="closeBtnPos == 'window'">
            <img src="~../assets/image/icon/btn_close.svg" width="30">
          </span>

          <div class="modal-header" v-if="this.$slots['header']">
            <slot name="header"></slot>
          </div>

          <div class="modal-body" v-if="this.$slots['body']">
            <slot name="body"></slot>
          </div>

          <div class="modal-footer" v-if="this.$slots['footer']">
            <slot name="footer">
              <button class="modal-default-button btn btn-primary" @click="$emit('close')">
                OK
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {

    name: 'Modal',

    props: {
      styleObject: {
        type: Object,
        required: false
      },
      closeBtnPos: {
        type: String,
        required: false,
        default: 'window'
      },
      top: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    data () {
      return {

      }
    }
  }
</script>

<style lang="scss" scoped>
  .top {
    z-index: 10000 !important;
  }

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    min-width: 300px;
    max-width: 100vh;
    max-height: 90vh;
    width: auto;
    height: auto;
    margin: 0px auto;
    padding: 10px 15px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    position: relative;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 15px 0;
    overflow: auto;
  }

  .modal-default-button {
    float: right;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .fullCloseBtn {
    cursor: pointer;
    position: absolute;
    right: 20px;
    top: 20px;
  }

  .windowCloseBtn {
    cursor: pointer;
    position: absolute;
    right: -10px;
    top: -10px;
  }
</style>


// WEBPACK FOOTER //
// modal.vue?034163ce